export default __webpack_public_path__ + "static/media/404error.1e7b89eb.png";